import { Fragment } from 'react';
import { useRole } from '../../lib/role';
import type { TermRef } from './search';
import { LABEL } from './texts';

/**
 * «Термины» в конце страницы (004, FR-008): термин и определение; на термин ведут ссылки из ответов правил. Два списка
 * (T106): «Слова расчёта» — всем; «Слова редактора правил» — тем, кто правит или утверждает правила. На телефоне —
 * одна колонка.
 */
/** Роли, которые правят или утверждают правила: им — ещё «Слова редактора правил». */
const EDITOR_ROLES: ReadonlySet<string> = new Set(['rules_admin', 'approver', 'sysadmin']);

function TermList({ label, terms }: { label: string; terms: readonly TermRef[] }) {
  if (terms.length === 0) return null;
  return (
    <div className="space-y-1.5">
      <h3 className="text-[13px] font-semibold text-ink-2">{label}</h3>
      <dl className="grid grid-cols-[180px_minmax(0,1fr)] gap-x-4 gap-y-2 rounded-card border border-line bg-surface px-4 py-3 text-[13.5px] max-sm:grid-cols-1 max-sm:gap-y-0.5">
        {terms.map((t) => (
          <Fragment key={t.id}>
            <dt
              id={t.id}
              className="scroll-mt-4 font-semibold break-words text-ink max-sm:pt-2 max-sm:first:pt-0"
            >
              {t.term}
            </dt>
            <dd className="m-0 break-words text-ink-2">{t.text}</dd>
          </Fragment>
        ))}
      </dl>
    </div>
  );
}

export function Terms({ terms }: { terms: readonly TermRef[] }) {
  const { role } = useRole();
  if (terms.length === 0) return null;
  const editor = EDITOR_ROLES.has(role) ? terms.filter((t) => t.editor) : [];
  return (
    <section id="terms" aria-labelledby="terms-title" className="scroll-mt-4 space-y-2.5">
      <h2 id="terms-title" className="text-[12px] font-semibold tracking-[0.07em] text-ink-3 uppercase">
        {LABEL.termsTitle}
      </h2>
      <TermList label={LABEL.termsCalc} terms={terms.filter((t) => !t.editor)} />
      <TermList label={LABEL.termsEditor} terms={editor} />
    </section>
  );
}
